function r(r) {
  var t = r && r.pop ? [] : {};
  for (var n in r) t[n] = r[n];
  return t;
}
export default function (t, n, l) {
  n.split && (n = n.split("."));
  for (var o = r(t), a = o, e = 0, f = n.length; e < f; e++) a = a[n[e]] = e === f - 1 ? l && l.call ? l(a[n[e]]) : l : r(a[n[e]]);
  return o;
}